import {
  ProductType,
  CabinBagsEnum,
  SOURCE_TYPE,
  TravellerAgeType,
} from 'enums';
import { getMarkups } from './availableCabinBags';

const DEFAULT_SELECTED_CABIN_BAGS_DATA = {
  selectedOption: CabinBagsEnum.SMALL_BAG,
  selectedSource: SOURCE_TYPE.DEFAULT,
  isRawSelection: false,
  travellers: [],
  itinerary: [],
  isDP: false,
  markups: {},
};

const getProductByType = (type, data) =>
  data?.getShoppingBundle?.products?.filter((p) => p.__typename === type)[0];

export const getAncillaryProduct = (data) =>
  getProductByType(ProductType.ANCILLARIES_PRODUCT, data);

export const getItineraryProduct = (data) =>
  getProductByType(ProductType.ITINERARY_PRODUCT, data) || {};

export const getAccommodationInfoProduct = (data) =>
  getProductByType(ProductType.ACCOMMODATION_INFO_PRODUCT, data);

export const getTravellers = (travellers) =>
  travellers?.length
    ? travellers.map((traveller) => {
        return {
          numPassenger: traveller.numPassenger,
          travellerType: traveller.personalInfo.ageType,
        };
      })
    : [];

export const getSelectedCabinBagsData = (data) => {
  if (!data) {
    return DEFAULT_SELECTED_CABIN_BAGS_DATA;
  }

  const ancillaryProduct = getAncillaryProduct(data);
  const itinerary = getItineraryProduct(data);
  const cabinBagsSelections =
    ancillaryProduct?.productInfo?.cabinBagsSelections;
  const type = cabinBagsSelections?.[0]?.type;
  const travellers = data?.getShoppingBundle?.travellers ?? [];

  return {
    selectedOption: Object.values(CabinBagsEnum).includes(type)
      ? type
      : CabinBagsEnum.SMALL_BAG,
    selectedSource: SOURCE_TYPE.DEFAULT,
    isRawSelection: false,
    /** @deprecated */
    fee: cabinBagsSelections?.[0]?.priceBreakdown.fee,
    /** @deprecated */
    primeFee: cabinBagsSelections?.[0]?.priceBreakdown.primeFee,
    markups:
      cabinBagsSelections && cabinBagsSelections.length > 0
        ? getMarkups(cabinBagsSelections)
        : {},
    travellers: getTravellers(travellers),
    itinerary: itinerary?.productInfo?.legs,
    isDP: !!getAccommodationInfoProduct(data),
    itineraryProduct: itinerary?.productInfo,
  };
};

const getTravellersWithoutInfants = (travellers) =>
  travellers.filter(
    (traveller) => traveller.travellerType !== TravellerAgeType.INFANT
  );

export const getSelectedCabinBagsForMutation = ({
  cabinBags,
  travellers,
  type,
}) => {
  if (type === CabinBagsEnum.SMALL_BAG) {
    return [];
  }

  return cabinBags.reduce((acc, cur) => {
    return [
      ...acc,
      ...getTravellersWithoutInfants(travellers).map((traveller) => ({
        section: cur.section,
        numPassenger: traveller.numPassenger,
        type,
      })),
    ];
  }, []);
};

export const mapShellTravellers = (shellTravellers) => {
  return shellTravellers.map((traveller, index) => ({
    numPassenger: index + 1,
    travellerType: traveller.travellerType,
  }));
};
